import ExternalSchoolIntegration from "../domain/data/ExternalSchoolIntegration";
import Organization from "../domain/entities/Organization";
import { SectionsData } from "../domain/entities/Section";
import Signatory from "../domain/entities/Signatory";
import Student from "../domain/entities/Student";
import { signatories, students } from './InitData';

export default class MockExternalSchoolRepository implements ExternalSchoolIntegration{
    async getGrades(organization: Organization, schoolYearStart: number, schoolYearEnd: number): Promise<string[]> {
        return [
            "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "PreKindergarten", "TransitionalKindergarten", "Kindergarten", "InfantToddler", "Preschool", "PostGraduate", "Ungraded", "Other", ""
        ];
    }
    async getStudents(organization: Organization, schoolYearStart: number, schoolYearEnd: number, grade: string): Promise<Student[]> {
        return students;
    }
    async getStudentSignatories(organization: Organization, schoolYearStart: number, schoolYearEnd: number, grade: string, student: Student): Promise<Signatory[]> {
        return signatories;
    }

    async getSections(schoolId: string): Promise<SectionsData[]> {
        throw new Error("Method not implemented.");
    }

    async getSchools(cleverToken: string): Promise<any> {
        throw new Error("Method not implemented.");
    }

    async getStaff(cleverToken: string, schoolId: string): Promise<any> {
        throw new Error("Method not implemented.");
    }

    async getStudent(cleverToken: string, studentId: string): Promise<any> {
        throw new Error("Method not implemented.");
    }

    async getContacts(cleverToken: string, studentId: string): Promise<any> {
        throw new Error("Method not implemented.");
    }

    async getToken(code: string, clientId: string, redirectURI: string): Promise<Response> {
        throw new Error("Method not implemented.");
    }

}